/*
 *
 * CustomIndicators reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_SURVEY_TYPES_FAILED,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_WATCHER,
  GET_SWITCH_SURVEY_TYPES_FAILED,
  GET_SWITCH_SURVEY_TYPES_SUCCESS,
  GET_SWITCH_SURVEY_TYPES_WATCHER,
} from "./constants"

export const initialState = fromJS({
  surveyTypes: [],
  isLoading: false,
})

function customIndicatorsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SWITCH_SURVEY_TYPES_WATCHER:
      return state.set("isLoading", true)
    case GET_SWITCH_SURVEY_TYPES_SUCCESS:
      return state.set("isLoading", false)
    case GET_SWITCH_SURVEY_TYPES_FAILED:
      return state.set("isLoading", false)
    case GET_SURVEY_TYPES_WATCHER:
      return state.set("surveyTypes", []).set("isLoading", true)
    case GET_SURVEY_TYPES_SUCCESS:
      return state.set("surveyTypes", action.payload).set("isLoading", false)
    case GET_SURVEY_TYPES_FAILED:
      return state.set("surveyTypes", []).set("isLoading", false)
    default:
      return state
  }
}

export default customIndicatorsReducer
